import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Waiter} from "../../shared/models/waiter";
import {WaiterService} from "../../core/http/waiter.service";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SimplePopupComponent} from "../../shared/components/simple-popup/simple-popup.component";
import {WaiterOverviewDetailsComponent} from "./waiter-overview-details/waiter-overview-details.component";
import {AuthService} from "../../core/auth/auth.service";
import {MatTableDataSource} from "@angular/material/table";
import {PrinterDto} from "../../shared/models/printer-dto";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-waiter-overview',
  templateUrl: './waiter-overview.component.html',
  styleUrls: ['./waiter-overview.component.scss']
})
export class WaiterOverviewComponent implements OnInit, AfterViewInit {

  waiters: Waiter[] = [];
  displayedColumns: string[] = ['firstName', 'lastName', 'street', 'houseNumber', 'zip', 'city', 'country', 'mobileNumber', 'email', 'createdBy', 'activeShift', 'details', 'delete'];
  userRoles: string[] | null = [];
  superAdmin = false;

  currentSelectedTenant = '';

  dataSource!: MatTableDataSource<Waiter>;
  tenantFilterValues: string[] = [];
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private waiterService: WaiterService, private dialog: MatDialog, private _snackBar: MatSnackBar, private authService: AuthService) {
    this.userRoles = this.authService.getUserRole();
    this.superAdmin = this.userRoles && <boolean>this.userRoles!.includes('superadmin');
    if (this.superAdmin) this.displayedColumns.unshift('tenantName');
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
    }
  }

  loadData(): void {
    this.waiterService.getAllWaiters().subscribe({
      next: (response) => {
        this.waiters = <Waiter[]>response;
        this.dataSource = new MatTableDataSource<Waiter>(this.waiters);
        this.dataSource.filterPredicate = (data: Waiter, filter: string) => {
          return data.tenantName?.toLowerCase() === filter;
        };
        this.dataSource.sort = this.sort;
        this.populateTenantFilterValues();
        if (this.currentSelectedTenant !== '') {
          this.applyFilter(this.currentSelectedTenant);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  populateTenantFilterValues(): void {
    const tenantSet = new Set<string>();
    this.waiters.forEach(waiter => {
      if (waiter.tenantName != null) {
        tenantSet.add(waiter.tenantName);
      }
    });
    this.tenantFilterValues = Array.from(tenantSet);
  }

  applyFilter(filterValue: string) {
    this.currentSelectedTenant = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  showLoginCode(waiter: Waiter): void {
    this.dialog.open(SimplePopupComponent, {
      data: {title: 'Login Code', message: waiter.loginCode},
      width: '200px'
    });
  }

  showWaiterDetails(waiter: Waiter): void {
    this.dialog.open(WaiterOverviewDetailsComponent, {
      data: {
        waiter: waiter
      }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      if (result) {
        result.guid = waiter.guid;
        this.waiterService.updateWaiter(result).subscribe({
          next: (response) => {
            this._snackBar.open('Kellner geändert', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  deleteWaiter(waiter: Waiter): void {
    this.dialog.open(YesNoModalComponent, {
      data: waiter.firstName + ' ' + waiter.lastName,
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        /*this.waiterService.deleteWaiter(waiter.guid).subscribe(result => {
            this._snackBar.open('Kellner ' + waiter.firstName + ' ' + waiter.lastName + ' gelöscht', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
            error: (err) => {
            if (err.status === 409) {
              this._snackBar.open('Eintrag ist noch aktiv und kann nicht gelöscht werden.', 'Schließen', {
                duration: 4000
              });
            } else {
              console.error('Unerwarteter Fehler:', err);
            }
          }
        });*/

        this.waiterService.deleteWaiter(waiter.guid).subscribe({
          next: () => {
            this._snackBar.open('Kellner ' + waiter.firstName + ' ' + waiter.lastName + ' gelöscht', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (err) => {
            if (err.status === 409) {
              this._snackBar.open('Eintrag hat noch eine aktive Schicht und kann nicht gelöscht werden.', 'Schließen', {
                duration: 4000
              });
            } else {
              console.error('Unerwarteter Fehler:', err);
              this._snackBar.open('Kellner konnte nicht gelsöcht werden.', 'Schließen', {
                duration: 4000
              });
            }
          }
        });
      }
    });
  }
}
